import React from 'react'

const ManagerIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='54' height='48' viewBox='0 0 54 48'><g><g><path fill='#415055' d='M52 48c-2.198 0-2-2-2-2v-5c0-2.681-11.624-7-23-7S4 38.319 4 41v5s.198 2-2 2-2-2-2-2v-6c0-.799 6.262-10 27-10s27 9.201 27 10v6s.198 2-2 2zM29 27h-4a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8h4a8 8 0 0 1 8 8v11a8 8 0 0 1-8 8zm5-17a7 7 0 0 0-14 0v7a7 7 0 0 0 14 0z' /></g></g></svg>
)

export default ManagerIcon
